import { FilterOptionList, VisibleEnumSelect } from '@yeshuman/sdk'
import type { FilterDefinition, FilterOption } from '@yeshuman/sdk'
import { HeartPulse } from 'lucide-react'

import { CONDITION_STATUS_LABELS } from '../components/condition-card'
import type { ConditionClinicalStatus, ConditionFilters } from '../hooks/use-conditions'

export const CONDITION_STATUS_OPTIONS: FilterOption[] = [
  { value: 'all', label: 'All' },
  ...Object.entries(CONDITION_STATUS_LABELS).map(([value, label]) => ({ value, label })),
]

export function getHealthConditionFilterDefinitions(): FilterDefinition<ConditionFilters, undefined>[] {
  return [
    {
      key: 'clinical_status',
      label: 'Status',
      icon: HeartPulse,
      displayValue: (filters) =>
        CONDITION_STATUS_OPTIONS.find((o) => o.value === filters.clinical_status)?.label ?? 'All',
      isNonDefault: (filters) => Boolean(filters.clinical_status),
      reset: (filters) => ({ ...filters, clinical_status: undefined }),
      renderField: ({ filters, onChange }) => (
        <VisibleEnumSelect
          value={filters.clinical_status ?? 'all'}
          options={CONDITION_STATUS_OPTIONS}
          onValueChange={(v) =>
            onChange({
              ...filters,
              clinical_status: v === 'all' ? undefined : (v as ConditionClinicalStatus),
            })
          }
        />
      ),
      renderPopover: ({ filters, onChange }) => (
        <FilterOptionList
          type="single"
          options={CONDITION_STATUS_OPTIONS}
          value={filters.clinical_status ?? 'all'}
          onValueChange={(v) =>
            onChange({
              ...filters,
              clinical_status: v === 'all' ? undefined : (v as ConditionClinicalStatus),
            })
          }
        />
      ),
    },
  ]
}
